module.exports = __webpack_public_path__ + "static/media/RecomendaJeri.0c494c28.jpg";